import React from "react";
import { Box, Flex, Heading, IconBellRinging, IconMemberDiscount, IconOnePassDelivery, IconOnePassTags, Link, LinkButton, Span, Text } from "@catchoftheday/cg-components";
import { BenefitBox } from "./BenefitBox";
import { OnePassHeader } from "@header-app/components/OnePassHeader";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var BENEFITS = [{
  icon: ___EmotionJSX(IconOnePassDelivery, {
    title: "Free delivery with OnePass",
    height: "26px",
    width: "auto"
  }),
  title: "Free Delivery",
  subtitle: "On thousands of eligible products"
}, {
  icon: ___EmotionJSX(IconMemberDiscount, {
    title: "OnePass member only pricing",
    height: "36px",
    width: "auto"
  }),
  title: "Member only pricing",
  subtitle: "Member prices on thousands of products"
}, {
  icon: ___EmotionJSX(IconOnePassTags, {
    title: "OnePass exclusive deals",
    height: "34px",
    width: "auto"
  }),
  title: "Exclusive deals",
  subtitle: "Access to exclusive weekly deals"
}, {
  icon: ___EmotionJSX(IconBellRinging, {
    title: "OnePass early alerts",
    height: "30px",
    width: "auto"
  }),
  title: "Early alerts",
  subtitle: "Get priority alerts to the best deals"
}];
export var PopupContent = function PopupContent(_ref) {
  var hideContent = _ref.hideContent,
      hasBeenOnePassMember = _ref.hasBeenOnePassMember,
      renewalCartUrl = _ref.renewalCartUrl;

  if (hideContent) {
    return null;
  }

  return ___EmotionJSX(Flex, {
    width: "400px",
    flexDirection: "column",
    color: "typography.text",
    boxShadow: "0 2px 4px 0 rgba(0,0,0,0.50)",
    bg: "white",
    borderRadius: "16px",
    overflow: "hidden",
    fontFamily: "onePass"
  }, ___EmotionJSX(OnePassHeader, null, ___EmotionJSX(Heading.h3, {
    fontFamily: "inherit",
    fontWeight: "bold",
    m: "0px",
    mb: "10px",
    color: "inherit"
  }, "Join for incredible benefits!"), ___EmotionJSX(Text, {
    m: "0",
    textAlign: "center",
    fontSize: "xs",
    fontWeight: "medium"
  }, !hasBeenOnePassMember ? "After your 30 day free trial, OnePass is only $4/month or\n              $40/year. Cancel anytime." : "OnePass is only $4/month or $40/year. Cancel anytime.")), ___EmotionJSX(Box, {
    py: "20px",
    px: "14px"
  }, ___EmotionJSX(Flex, {
    mb: "12px",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  }, ___EmotionJSX(LinkButton, {
    block: false,
    fontWeight: "semibold",
    sizeVariant: "sm",
    variant: "onePassPrimary",
    href: hasBeenOnePassMember ? renewalCartUrl : "/onepass",
    "data-tracking": hasBeenOnePassMember ? "header-app-onepass-renew-onepass" : "header-app-onepass-join-onepass"
  }, hasBeenOnePassMember ? "Join OnePass" : "Start free 30 Day Trial")), ___EmotionJSX(Flex, {
    flexWrap: "wrap"
  }, BENEFITS.map(function (benefit, idx) {
    return ___EmotionJSX(BenefitBox, {
      key: "onepass-benefit-".concat(idx),
      icon: benefit.icon,
      title: benefit.title,
      subtitle: benefit.subtitle
    });
  })), ___EmotionJSX(Flex, {
    mt: "10px",
    alignItems: "center",
    justifyContent: "center"
  }, ___EmotionJSX(Span, {
    fontSize: "xs",
    fontWeight: "bold",
    color: "onePass.primary"
  }, ___EmotionJSX(Link, {
    href: "/onepass",
    color: "inherit",
    textDecoration: "underline"
  }, "Learn more"), " ", "|", " ", ___EmotionJSX(Link, {
    href: "/onepass-terms",
    color: "inherit",
    textDecoration: "underline"
  }, "Terms & Conditions")))));
};